export default __webpack_public_path__ + "static/media/image1.54e17b5d.jpg";